import React, {
  Suspense,
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Select, Input, Form, message, Spin } from "antd";
import {
  getAllCustomerListApi,
  getAllCustomerLocationListApi,
  getCustomerProjectsListApi,
  getCustomerDefaultProjectRecords,
  getNonStockItemRecordsApi,
  addNewAppointmentAPI,
  // getServiceContractsByCustomerApi, // TODO: re-enable service contract
} from "../AddAppointment/CreateAppointmentAPI";
import { useHistory } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

function CreateAppointment(props) {
  const intl = useIntl();
  const Option = Select.Option;
  const { TextArea } = Input;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();

  const { customerRecords = [] } = useSelector(
    (state) => state.CreateAppointment,
  );
  const { customerLocationRecords = [] } = useSelector(
    (state) => state.CreateAppointment,
  );
  const { CustomerprojectRecords = [] } = useSelector(
    (state) => state.CreateAppointment,
  );
  const { customerDefaultProject = [] } = useSelector(
    (state) => state.CreateAppointment,
  );
  const { serviceItemsList = [] } = useSelector(
    (state) => state.CreateAppointment,
  );
  // const { serviceContractList = [] } = useSelector( // TODO: re-enable service contract
  //   (state) => state.CreateAppointment,
  // );
  const { modalLoading = false } = useSelector(
    (state) => state.CreateAppointment,
  );

  var empId = localStorage.getItem("employeeId");

  useEffect(() => {
    dispatch(getAllCustomerLocationListApi());
  }, [dispatch]);

  const [SrvOrdtypeSelected, setSrvOrdtypeSelected] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [selectedLocation, setSelectedLocation] = useState();
  const [selectedProject, setSelectedProject] = useState();
  const [selectedDefaultProject, setSelectedDefaultProject] = useState();
  // const [selectedServiceContract, setSelectedServiceContract] = useState(null); // TODO: re-enable service contract
  const [isrequired, setIsrequired] = useState(false);
  const [locationSearchValue, setLocationSearchValue] = useState("");

  const excludeServiceItems = ["S.TEC OVERHEAD", "S.TEC CCQ OVERHEAD"];

  // Debounce timer ref
  const debounceTimer = useRef(null);

  const handleSrvOrdtypeSelected = (value, option, allRecords) => {
    if (value == undefined) {
      setSrvOrdtypeSelected(undefined);
      form.setFieldsValue({
        location: undefined,
        customer: undefined,
        projectSO: undefined,
        defaultProjectTask: undefined,
        inventoryID: undefined,
      });
      setSelectedRecord(null);
      setSelectedLocation(null);
    } else {
      const SrvOrdtypeSelected = allRecords.find(
        (record) => record.value === value,
      );
      setSrvOrdtypeSelected(SrvOrdtypeSelected);
    }
  };
  // Add a ref to track if user is selecting vs searching
  const isSelectingRef = useRef(false);

  // Debounced search for locations
  const handleLocationSearch = useCallback(
    (value) => {
      // Don't search if user is selecting an option
      if (isSelectingRef.current) {
        isSelectingRef.current = false;
        return;
      }

      setLocationSearchValue(value);

      // Clear previous timer
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }

      // Only search if there's actual input (minimum 2 characters)
      if (value && value.trim().length >= 2) {
        // Set new timer for 500ms
        debounceTimer.current = setTimeout(() => {
          dispatch(getAllCustomerLocationListApi(value.trim()));
        }, 500);
      }
      // Don't reload on empty - keep current results
    },
    [dispatch],
  );

  const handleLocationSelected = (value, option) => {
    // Set flag to prevent search trigger
    isSelectingRef.current = true;

    if (value === undefined || value === null) {
      setSelectedLocation(null);
      setSelectedRecord(null);
      form.setFieldsValue({
        customer: undefined,
        projectSO: undefined,
        defaultProjectTask: undefined,
        inventoryID: undefined,
      });
    } else {
      // Value is now "businessAccountID|locationID"
      const [businessAccountID, locationID] = value.split("|");

      // Find the selected location from the records
      const selectedLocationData = customerLocationRecords.find(
        (record) =>
          record.businessAccountID === businessAccountID &&
          record.locationID === locationID,
      );

      setSelectedLocation(selectedLocationData);

      // Auto-populate customer field with BusinessAccountID
      if (selectedLocationData?.businessAccountID) {
        form.setFieldsValue({
          customer: selectedLocationData.businessAccountID,
        });

        // Find the actual customer record from customerRecords
        const customerRecord = customerRecords.find(
          (record) =>
            record.customerID === selectedLocationData.businessAccountID,
        );

        if (customerRecord) {
          setSelectedRecord(customerRecord);
        } else {
          // If customer not found in list, create a minimal record
          const tempCustomerRecord = {
            customerID: selectedLocationData.businessAccountID,
            customerName:
              selectedLocationData.businessAccountName ||
              selectedLocationData.businessAccountID,
          };
          setSelectedRecord(tempCustomerRecord);
        }
      }

      // Clear dependent fields
      form.setFieldsValue({
        projectSO: undefined,
        defaultProjectTask: undefined,
        inventoryID: undefined,
      });
    }
  };

  const handleCustomerSelected = (value, option, allRecords) => {
    if (value === undefined) {
      setSelectedRecord(null);
      form.setFieldsValue({
        projectSO: undefined,
        defaultProjectTask: undefined,
        inventoryID: undefined,
      });
    } else {
      const selectedRecord = allRecords.find(
        (record) => record.customerID === value,
      );
      setSelectedRecord(selectedRecord);
      form.setFieldsValue({
        projectSO: undefined,
        defaultProjectTask: undefined,
        inventoryID: undefined,
      });
    }
  };

  useEffect(() => {
    if (selectedRecord != null && selectedRecord != undefined) {
      dispatch(getCustomerProjectsListApi(selectedRecord.customerID));
      // dispatch(getServiceContractsByCustomerApi(selectedRecord.customerID)); // TODO: re-enable service contract
      dispatch(getNonStockItemRecordsApi("Service"));
    }
  }, [selectedRecord, dispatch]);

  const handleProjectSelected = (value, option, allRecords) => {
    if (value === undefined) {
      setSelectedProject(null);
      setIsrequired(false);
      form.setFieldsValue({
        defaultProjectTask: undefined,
      });
    } else {
      const selectedProject = allRecords.find(
        (record) => record.projectID === value,
      );

      if (
        selectedProject?.projectID === "X" ||
        selectedProject?.projectID == undefined
      ) {
        setIsrequired(false);
        form.setFieldsValue({
          defaultProjectTask: undefined,
        });
      } else {
        setIsrequired(true);
      }
      setSelectedProject(selectedProject);
    }
  };

  useEffect(() => {
    if (selectedProject != null && selectedProject != undefined) {
      if (selectedProject.projectID != "X") {
        dispatch(getCustomerDefaultProjectRecords(selectedProject?.projectID));
      }
    }
  }, [selectedProject, dispatch]);

  const handleDefaultProjectSelected = (value, option, allRecords) => {
    if (value === undefined) {
      setSelectedDefaultProject(null);
    } else {
      const selectedDefaultProject = allRecords.find(
        (record) => record.projectTaskID === value,
      );
      setSelectedDefaultProject(selectedDefaultProject);
    }
  };

  const serviceOrderTypes = [
    {
      Name: "TMVT",
      value: "TMVT",
      description: "Temps et Matériels Ventilation",
    },
    {
      Name: "TMCB",
      value: "TMCB",
      description: "Temps et Matériels Combustion",
    },
    {
      Name: "TMCT",
      value: "TMCT",
      description: "Temps et Matériels Contrôle",
    },
  ];

  const handleInventorySelected = (value, option, allRecords) => {
    // No additional logic needed for now
  };

  const handelCreateApp = async () => {
    try {
      const values = await form.validateFields();

      // Extract just the locationID from the combined value
      const locationValue = values.location
        ? values.location.split("|")[1]
        : null;

      const details = [
        {
          lineType: "Service",
          inventoryID: values.inventoryID,
          staffMemberID: localStorage.getItem("employeeId"),
        },
      ];

      const payload = {
        serviceOrderType: values.serviceOrderType,
        customer: values.customer,
        location: locationValue, // Use just the locationID
        branchLocation: null,
        // serviceContract: values.serviceContract || null, // TODO: re-enable service contract
        projectSO: values.projectSO,
        defaultProjectTask: values.defaultProjectTask,
        problemDescription: values.problemDescription,
        details: details,
        StaffMember: localStorage.getItem("employeeId"),
      };

      dispatch(addNewAppointmentAPI(payload, refreshURL));
      props.setIsModalOpen(false);
      form.resetFields();
      setSelectedRecord(null);
      setSelectedLocation(null);
      setSelectedProject(null);
      // setSelectedServiceContract(null); // TODO: re-enable service contract
      setLocationSearchValue("");
    } catch (error) {
      console.error("Validation failed", error);
    }
  };

  const refreshURL = (noteID) => {
    noteID != null
      ? history.push(`/appointment/${noteID}/summary`)
      : history.push(`/dashboard`);
  };

  const commonFilterOption = (input, option) => {
    const optionLabel =
      (option.children && option.children.toString().toUpperCase()) ||
      (option.label && option.label.toString().toUpperCase()) ||
      (option.value &&
        option.value.description &&
        option.value.description.toUpperCase());

    return optionLabel.indexOf(input.toUpperCase()) >= 0;
  };

  useEffect(() => {
    if (props.createAppFormReset) {
      form.resetFields();
      setSelectedRecord(null);
      setSelectedLocation(null);
      setSelectedProject(null);
      // setSelectedServiceContract(null); // TODO: re-enable service contract
      setLocationSearchValue("");
    }
  }, [props, form]);

  // Cleanup debounce timer on unmount
  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);
  console.log(
    "customerLocationRecords",
    customerLocationRecords,
    customerRecords,
  );
  return (
    <Spin spinning={modalLoading} size="large">
      <div
        id="modal-body"
        style={{ maxHeight: "60vh", overflowY: "auto", position: "relative" }}
      >
        <Form
          form={form}
          name="basic"
          layout="horizontal"
          labelWrap
          colon={false}
          className="mt-20 form-new-kolotech"
          style={{ paddingBottom: "10px" }}
          labelCol={{
            span: 6,
            xs: 8,
            md: 8,
            lg: 6,
            xl: 6,
          }}
          wrapperCol={{
            span: 18,
            xs: 16,
            md: 18,
            lg: 18,
            xl: 17,
          }}
          initialValues={{
            remember: false,
          }}
        >
          <Form.Item
            label={<FormattedMessage id="Appointment.ServiceOrderType" />}
            name="serviceOrderType"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage id="Appointment.PleaseselectServiceOrderType" />
                ),
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder={
                <FormattedMessage id="Appointment.PleaseselectServiceOrderType" />
              }
              allowClear
              filterOption={commonFilterOption}
              onChange={(value, option) =>
                handleSrvOrdtypeSelected(value, option, serviceOrderTypes)
              }
            >
              {serviceOrderTypes.map((record) => (
                <Option key={record.value} value={record.value}>
                  {`${record.value} - ${record.description}`}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={<FormattedMessage id="Equipments.Location" />}
            name="location"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage id="Appointment.PleaseselectLocation" />
                ),
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder={
                <FormattedMessage id="Appointment.PleaseselectLocation" />
              }
              allowClear
              filterOption={false}
              onSearch={handleLocationSearch}
              onChange={handleLocationSelected}
              notFoundContent={null}
            >
              {Array.isArray(customerLocationRecords) &&
                customerLocationRecords.map((record, index) => (
                  <Option
                    key={`${record.businessAccountID}-${record.locationID}-${index}`}
                    value={`${record.businessAccountID}|${record.locationID}`}
                    record={record}
                  >
                    {`${record.locationID} - ${record.locationName} (${record.businessAccountID} - ${record.businessAccountName})`}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={<FormattedMessage id="Appointment.Customer" />}
            name="customer"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage id="Appointment.PleaseselectCustomer" />
                ),
              },
            ]}
          >
            <Select
              // disabled={true}
              showSearch
              style={{ width: "100%" }}
              placeholder={
                <FormattedMessage id="Appointment.PleaseselectCustomer" />
              }
              allowClear
              required={true}
              disabled={true} // Enabled only after location selected
              filterOption={commonFilterOption}
              onChange={(value, option) =>
                handleCustomerSelected(value, option, customerRecords)
              }
            >
              {customerRecords.map((record) => (
                <Option key={record.customerID} value={record.customerID}>
                  {`${record.customerID} - ${record.customerName}`}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {/* TODO: re-enable service contract
          <Form.Item
            label={<FormattedMessage id="Appointment.ServiceContract" />}
            name="serviceContract"
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder={
                <FormattedMessage id="Appointment.ServiceContract" />
              }
              allowClear
              disabled={!selectedRecord}
              filterOption={commonFilterOption}
              onChange={(value) => setSelectedServiceContract(value || null)}
            >
              {serviceContractList.map((record) => (
                <Option
                  key={record.serviceContractID}
                  value={record.serviceContractID}
                >
                  {`${record.serviceContractID}${record.description ? ` - ${record.description}` : ""}`}
                </Option>
              ))}
            </Select>
          </Form.Item>
          */}

          <Form.Item
            label={<FormattedMessage id="Appointment.Project" />}
            name="projectSO"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage id="Appointment.PleaseselectProject" />
                ),
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder={
                <FormattedMessage id="Appointment.PleaseselectProject" />
              }
              allowClear
              disabled={!selectedRecord} // Enabled only after customer selected
              filterOption={commonFilterOption}
              onChange={(value, option) =>
                handleProjectSelected(value, option, CustomerprojectRecords)
              }
            >
              {CustomerprojectRecords.map((record) => (
                <Option key={record.projectID} value={record.projectID}>
                  {`${record.projectID} - ${record.description}`}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={<FormattedMessage id="Appointment.DefaultProjectTask" />}
            name="defaultProjectTask"
            rules={[
              {
                required: isrequired,
                message: (
                  <FormattedMessage id="Appointment.PleaseselectdefaultProjectTask" />
                ),
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder={
                <FormattedMessage id="Appointment.PleaseselectdefaultProjectTask" />
              }
              allowClear
              disabled={!isrequired}
              filterOption={commonFilterOption}
              onChange={(value, option) =>
                handleDefaultProjectSelected(
                  value,
                  option,
                  customerDefaultProject,
                )
              }
            >
              {customerDefaultProject.map((record) => (
                <Option key={record.projectTaskID} value={record.projectTaskID}>
                  {`${record.projectTaskID} - ${record.description}`}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={<FormattedMessage id="Summary.ProblemDescription" />}
            name="problemDescription"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage id="Appointment.PleaseselectProblemDescription" />
                ),
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>

          <h4>
            {" "}
            <FormattedMessage id="Appointment.Details" />
          </h4>

          <Form.Item
            label={<FormattedMessage id="Appointment.Inventory" />}
            name="inventoryID"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage id="Appointment.PleaseselectInventory" />
                ),
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              getPopupContainer={() => document.getElementById("modal-body")}
              placeholder={
                <FormattedMessage id="Appointment.PleaseselectInventory" />
              }
              allowClear
              disabled={!selectedRecord}
              filterOption={commonFilterOption}
              onChange={(value, option) =>
                handleInventorySelected(value, option, serviceItemsList)
              }
            >
              {serviceItemsList
                .filter(
                  (record) => !excludeServiceItems.includes(record.inventoryID),
                )
                .map((record) => (
                  <Option key={record.inventoryID} value={record.inventoryID}>
                    {`${record.inventoryID} - ${record.description}`}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            style={{ borderBottom: "none" }}
            label={<FormattedMessage id="Appointment.lineType" />}
            name="lineType"
          >
            <Input
              value={"Service"}
              placeholder={intl.formatMessage({
                id: "Appointment.Service",
              })}
              disabled={true}
            ></Input>
          </Form.Item>
        </Form>
      </div>
      <div
        className="text-right"
        style={{
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: "12px 24px",
          paddingBottom: "0",
          borderTop: "1px solid #f0f0f0",
          zIndex: 10,
        }}
      >
        <Button type="primary" onClick={() => handelCreateApp()}>
          <FormattedMessage id="Appointment.CreateAppointment" />
        </Button>
      </div>
    </Spin>
  );
}
export default CreateAppointment;
